export default __webpack_public_path__ + "static/media/Logger-dark.eb07bee6.svg";